module.exports = {"id":"collection-lend_a_helping_hand","slug":"lend-a-helping-hand","name":"Lend a helping hand","short_description_html":"Selflessly coming together to lift the spirits of those in need.","products":["product-cupcake_tester_t_shrit_by_john_doe"]}


//////////////////
// WEBPACK FOOTER
// ./src/store/data/collections/collection-lend_a_helping_hand.json
// module id = ./src/store/data/collections/collection-lend_a_helping_hand.json
// module chunks = 2